import { Alert } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { HELP_CENTER_URL } from "@jugl-web/utils/consts";
import infoGif from "./assets/info.gif";

export const CopyLinkFailedAlert = ({
  isOpen,
  onRequestClose,
}: {
  isOpen: boolean;
  onRequestClose: () => void;
}) => {
  const { t } = useTranslations();

  return (
    <Alert
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="h-[316px] w-[448px]"
      imgContainerClassName="mb-0"
      titleAndContentContainerClassName="gap-2"
      contentContainerClassName="p-0 pt-4 px-6 pb-10"
      img={<img src={infoGif} alt="Info" className="w-[104px h-[104px]" />}
      title={t({
        id: "cpanel-page.copy-link-failed",
        defaultMessage: "Couldn’t copy the link",
      })}
      content={
        <div className="text-sm">
          {t({
            id: "cpanel-page.copy-link-failed-description",
            defaultMessage:
              "Something went wrong during the copy process. Your browser may be blocking clipboard access.",
          })}
        </div>
      }
      buttonsContainerClassName="mt-8 flex justify-center [&>button]:flex-none gap-4"
      buttons={[
        {
          text: t({
            id: "common.close",
            defaultMessage: "Close",
          }),
          color: "grey",
          onClick: onRequestClose,
          className:
            "h-[40px] w-[112px] font-secondary text-dark-800 font-medium text-sm",
        },
        {
          className: "h-[40px] w-[181px] font-secondary font-medium text-sm",
          text: t({
            id: "common.help",
            defaultMessage: "Help",
          }),
          color: "primary",
          onClick: () =>
            window.open(HELP_CENTER_URL, "_blank", "noopener noreferrer"),
        },
      ]}
    />
  );
};
